  window.addEventListener('load', () => {
    const _m = {
      getAllLinks: () => document.querySelectorAll('.gdc-sidebar__nav-links-item-link'),
      getLink: (id) => document.querySelector(`[data-link="${id}"]`),
      isAnchor: (link) => link.dataset.link.includes('#') && link.dataset.link.length > 1,
      getIds: () => [..._m.getAllLinks()]
                      .filter(link => _m.isAnchor(link))
                      .map(link => link.dataset.link),
      unfocusLink: (link) => link.classList.remove('gdc-sidebar-focus'),
      hideAllSidebarIndicators: () => _m.getAllLinks().forEach(link => _m.unfocusLink(link)),
      showCurrentIndicator: (id) => _m.getLink(id).classList.add('gdc-sidebar-focus'),
      elementToObserve: (id) => document.querySelector(`[data-sidebar-indicator="${id}"]`)
    }

    function showCurrentSidebarIndicatorOnScroll(id) {
      _m.hideAllSidebarIndicators()
      _m.showCurrentIndicator(id)
    }

    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        let indicator = entry.target.dataset.sidebarIndicator

        if (entry.intersectionRatio > 0) {
          showCurrentSidebarIndicatorOnScroll(indicator)
        } 
      });
    });

    _m.getIds().map(id => {
      observer.observe(_m.elementToObserve(id));
    })

  })